import { PaginatedBoothList } from '@goldcast/api/backend';

import { Booth, Booths } from './types';

import { transformServerRooms } from '@/studio/rooms/store/utils';

export function transformServerBooths(booths: Booth[] | PaginatedBoothList): Booths {
  const transformedBooth: Record<number, Booth> = {};

  Array.isArray(booths) &&
    booths.forEach((booth: Booth) => {
      booth.discussionGroupObjects = transformServerRooms(booth.discussion_group_objects);
      booth.image = getBoothImage(booth);
      transformedBooth[booth.id] = booth;
    });
  return transformedBooth as Booths;
}

export function getBoothImage(booth: Booth): string {
  if (booth.hero_asset_type === 'hero_asset_image') {
    return booth.hero_asset;
  }
  if (booth.hero_asset_type === 'hero_asset_video') {
    return booth.poster;
  }
  return '';
}
